import { render, staticRenderFns } from "./BusinessYearSelect.vue?vue&type=template&id=1a192a3a"
import script from "./BusinessYearSelect.vue?vue&type=script&lang=ts"
export * from "./BusinessYearSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports